import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { FilterGetLink } from 'src/Models/CRRALinkModel';

@Injectable({
  providedIn: 'root'
})
export class CrraLinkMasterService {

  AppUrl = '';
  FilterGetLink = new FilterGetLink();

  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
      this.AppUrl = sessionStorage.getItem('BaseURL') || '';
    }
  }


  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }

  GetAllLink(TokenKey: string, PageNumber: number, PageSize: number, linkId: string, stateId: string, orderBy: string): Observable<any> {
    this.setAPIUrl();
    const data = 'api/CRRALinkMaster/GetAllLink/' + linkId + '/' + stateId + '/' + PageNumber + '/' + PageSize + '/' + orderBy;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  LinkAddUpdate(TokenKey: string, addNewActionModel: any): Observable<any> {
    this.setAPIUrl();
    const URL = this.AppUrl + 'api/CRRALinkMaster/LinkAddUpdate';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, addNewActionModel, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetLinkById(TokenKey: string, linkId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/CRRALinkMaster/GetLinkById/' + linkId ;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  DeleteLink(TokenKey: string, linkId: number): Observable<any> {
    this.setAPIUrl();
    const data = 'api/CRRALinkMaster/DeleteLink/' + linkId ;
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetLinkType(TokenKey: string): Observable<any> {
    this.setAPIUrl();
    const data = 'api/CRRALinkMaster/GetLinkType';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.get<any>(this.AppUrl + data, httpOptions)
      .pipe(catchError(this.handleError));
  }

  GetAllLinkV2(TokenKey: string, PageNumber: number, PageSize: number, linkId: string, stateId: string, orderBy: string,_IsExport:boolean): Observable<any> {
    this.setAPIUrl();

    this.FilterGetLink = {
      pageNumber: PageNumber,
      pageSize: PageSize,
      linkTypeId: linkId,
      stateId,
      orderBy,
      IsExport:_IsExport
    };

    const URL = this.AppUrl + 'api/CRRALinkMaster/V2/GetAllLink';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
    return this._http.post<any>(URL, this.FilterGetLink , httpOptions)
      .pipe(catchError(this.handleError));
  }
}
